import { baseApi } from "../baseApi";

export const putawayApi = baseApi.injectEndpoints({
      endpoints: (builder) => ({
    postPutawayList: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.get_putaway_list`,
        method: 'post',
        body: data
      })
    }),
    postPutawayUpdate: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.update_put_away`,
        method: 'post',
        body: data
      })
    }),
    postPutawayCreation: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.create_put_away`,
        method: 'post',
        body: data
      })
    }),
    postActiveSNO: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_active_serial_nos`,
        method: 'post',
        body: data
      })
    }),
    postActiveSNoPutAway: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_create_put_away_details`,
        method: 'post',
        body: data
      })
    }),
    postPutawaySubmit: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.submit_put_away`,
        method: 'post',
        body: data
      })
    }),
    getPutawayDetail: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_create_put_away_details`,
        method: 'post',
        body: data
      })
    }),
    getStockEntryDetails: builder.query({
      query: (stockEntry) => ({
        url: '/api/method/stackerbee_mobile_wms.wms.react_api.get_stock_entry_details',
        params: { stock_entry_id: stockEntry },
      }),
    }),
    getPutawayDetails: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_putaway_details`,  // Corrected here
        method: 'post',
        body: data,
      }),
    }),
   
  }),
});

export const { usePostActiveSNoPutAwayMutation,usePostPutawayUpdateMutation,useGetPutawayDetailsMutation, useGetStockEntryDetailsQuery, usePostPutawayListMutation, useGetPutawayDetailMutation, usePostPutawayCreationMutation, usePostPutawaySubmitMutation, usePostActiveSNOMutation } = putawayApi


